import { roleListReducer } from './reducers';

export default {
  roleList: roleListReducer
};
